<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-data-table
          :key="1"
          :headers="headers"
          :items="visibleItems"
          :items-per-page="table.itemsPerPage"
          :footer-props="table.footerProps"
          :options.sync="table.options"
          :server-items-length="table.total"
          :show-expand="false"
          :expanded="[]"
          :loading="table.loading"
          :item-class="rowClass"
          loading-text="loading"
          must-sort
          sort-by="badgeId"
          sort-desc
          no-data-text="No badges found"
          no-results-text="No badges found"
          item-key="badgeId"
          id="badge-table"
          class="cursor-pointer badge-table"
          @click:row="selectItem($event)"
        >
          <template v-slot:[`item.select`]="{ item }">
            <v-simple-checkbox
              color="brandCyan"
              @click.stop="selectItem(item, false)"
              :ripple="false"
              :value="selected.find((x) => x.badgeId == item.badgeId) ? true : false"
            />
          </template>
          <template v-slot:[`item.displayName`]="{ item }">
            <span class="word-break">{{ item.displayName }}</span>
          </template>
          <template v-slot:[`item.imageUrl`]="{ item }">
            <v-img
              :src="item.imageUrl"
              class="selectable-blue-text"
              max-width="32"
              :aspect-ratio="1 / 1"
            >
            </v-img>
          </template>

          <template v-slot:loading>
            <!-- {{ item }} -->
            <v-progress-circular
              indeterminate
              color="primary"
              class="my-8"
              :size="50"
              :width="4"
            ></v-progress-circular>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// Services
import BadgeService from "@/services/BadgeServiceV2";

import { mapState } from "vuex";

export default {
  name: "UsersTable",
  props: {
    selected: {
      type: Array,
    },
    search: {
      type: String,
    },
    sourcePage: {
      type: String,
      default: "programadmin",
    },
    sourcePageProps: {
      type: Object,
      default: undefined,
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
    showType: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data() {
    return {
      badgeService: new BadgeService(),
      whistleClientId: 1,
      loading: {
        assignments: false,
      },
      dialog: {
        preview: false,
      },
      item: null,
      table: {
        itemsPerPage: 10,
        page: 1,
        // Used if the user ends up mashing the table page button, then we're waiting on multiple responses so we know which page to actually store the data for
        awaitingPage: 1,
        search: null,
        debounceSearch: null,
        loading: false,
        items: [],
        total: 0,
        selected: [],
        options: {},
        footerProps: {
          "items-per-page-options": [10, 25, 50, 100],
        },
        latestFilter: null,
        latestSort: null,
      },
    };
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  methods: {
    loadAction(item) {
      console.log("loading action ", item);
      this.$emit("load-action", item);
    },
    async getBadges(reset = false, source = null, preloadBadge = null) {
      try {
        console.log("Getting badges ", { source, reset, preloadBadge });

        let addedBadge = false;
        if (preloadBadge && typeof preloadBadge == "object") {
          this.selectItem(preloadBadge);
          addedBadge = true;
          console.log("Adding badge before API call because it's an object");
        }

        this.table.loading = true;
        if (reset) this.table.options.page = 1;
        let options = this.table.options;
        let page = this.table.options.page || 1;
        // let search = this.search ? this.search.replace(/'/g, "\\'") : null;
        let filter = `status != 'Deleted' && clientId = ${this.clientId}`;

        let limit = options.itemsPerPage;
        let offset = reset ? 0 : (page - 1) * limit;
        let sort = "badgeId DESC";
        if (this.table.options.sortBy && options.sortBy.length > 0) {
          let column = options.sortBy;
          console.log("Sort ", options);
          let type =
            options.sortDesc && options.sortDesc.length > 0 && options.sortDesc[0] === true
              ? "DESC"
              : "ASC";

          // if (column == "displayName")
          // sort = `User.firstName ${type}, User.lastName ${type}`;
          // else
          sort = column + " " + type;
        }
        this.table.latestSort = sort;
        this.table.latestFilter = filter;
        let params = {
          offset,
          limit,
          sort: sort + `, createDate ASC`,
          clientId: this.clientId,
          search: this.search,
          universal: true,
        };
        let response = await this.badgeService.getBadges(params);

        if (
          // filter != this.table.latestFilter ||
          this.search != params.search ||
          sort != this.table.latestSort ||
          page != this.table.options.page ||
          limit != this.table.options.itemsPerPage ||
          this.clientId != params.clientId
        ) {
          console.log("Ignoring badge response");
          return;
        }

        console.log("Got badges ", response);
        this.table.total = response?.result?.count;

        // If at the beginning we just grab the first results and then append the rest of the empty array
        // If not the beginning, we append the existing fetched array, then the new results, and anything after
        // this.table.users = rows;
        // if (offset == 0)
        this.table.items = response?.result?.rows || [];
        this.table.loading = false;

        if (preloadBadge && !addedBadge) {
          var foundBadge = this.table.items.find((x) => x.badgeId == preloadBadge);
          if (foundBadge) this.selectItem(foundBadge);
        }
      } catch (err) {
        console.log("Error getting badges ", err);
        this.table.loading = false;
      }
    },
    selectItem(x) {
      console.log("Selecting item ", x);
      this.$emit("select-item", x);
    },
    rowClass(item) {
      // console.log(item);
      if (item.clientId == 0 && this.userProfile.clientId != 1) {
        return "cursor-default";
      } else if (
        (this.userProfile.clientId == 1 && item.clientId == 0) ||
        this.permissions.includes("badges:create:badge")
      ) {
        // console.log('pointer cursor');
        return "cursor-pointer";
      }
    },
  },
  computed: {
    ...mapState(["userProfile", "permissions", "globalClientId", "clients", "magicLinkToken"]),
    clientId: {
      get: function () {
        return this.globalClientId;
      },
      set: function (newVal) {
        this.$store.dispatch("setClientId", newVal);
      },
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    visibleItems() {
      let array = this.table.items || [];

      // array = array.filter(x => x.status != "Deleted");

      if (this.table.loading) return [];
      return array;
    },
    headers() {
      let arr = [];

      if (this.showSelect) {
        arr.push({
          align: "start",
          sortable: false,
          value: "select",
          width: "35px",
        });
      }
      if (this.userProfile.clientId == 1 && this.showType) {
        arr.push(
          ...[
            { text: "Image", value: "imageUrl", width: "20%" },
            { text: "Name", value: "displayName", width: "30%" },
            { text: "Description", value: "description", width: "30%" },
            { text: "Type", value: "type", width: "20%" },
          ]
        );
      } else {
        arr.push(
          ...[
            { text: "Image", value: "imageUrl", width: "20%" },
            { text: "Name", value: "displayName", width: "40%" },
            { text: "Description", value: "description", width: "40%" },
          ]
        );
      }

      return arr;
      // return [
      //   { text: "Image", value: "imageUrl", width: "10%" },
      //   { text: "Name", value: "displayName", width: "30%" },
      //   { text: "Description", value: "description", width: "30%" },
      //   this.userProfile?.clientId === 1
      //     ? { text: "Type", value: "type", width: "20%" }
      //     : undefined
      // ].filter(Boolean);
    },
  },
  watch: {
    "table.options": {
      handler(newVal, oldVal) {
        console.log("New options ", newVal);
        console.log("Old options ", oldVal);
        // Used to indicate if we wipe the table and start with an empty array, versus pushing more data on
        var reset = false;
        var apiCall = true;
        // If none of these exist then we're probably loading the page for the first time so we reset
        if (!oldVal.itemsPerPage || !oldVal.page || !oldVal.sortBy || !oldVal.sortDesc)
          reset = true;
        else {
          // If any values changed from their old to new states, then we reset because they're changing a sort
          if (
            newVal.itemsPerPage !== oldVal.itemsPerPage ||
            (newVal.sortBy && oldVal.sortBy && newVal.sortBy[0] !== oldVal.sortBy[0]) ||
            (newVal.sortDesc && oldVal.sortDesc && newVal.sortDesc[0] !== oldVal.sortDesc[0])
          )
            reset = true;
        }

        if (apiCall) this.getBadges(reset, "watcher");
      },
      deep: true,
    },
    clientId: function (newVal, oldVal) {
      // If client id changes, we get budgets!
      if (newVal != oldVal && oldVal != null) {
        this.getBadges(true, "client watcher");
      }
    },
    search: function () {
      this.getBadges(true, "search watcher");
    },
  },
};
</script>

<style scoped>
.profile-pic-icon {
  height: 105px;
  width: 105px;
}

.v-data-table-header {
  background-color: var(--v-lightGrey-base);
}

.badge-table {
  border: solid 1px;
  border-color: lightgray;
  border-radius: 0;
}

.badge-table >>> .v-data-table-header {
  background-color: white;
}
</style>
